import { state } from "frer";
import data from "./tiny-setting";
const app$ = state({
    name: "app",
    initValue: "",
    producer(next,value,action){
        switch(action.type){
            case "save":
                next(action.app);
                break;
        }
    }
});
const list$ = state({
    name: "list",
    initValue: "",
    producer(next,value,action){
        switch(action.type){
            case "save":
                next(action.list);
                break;
        }
    }
});
const isApp$ = state({
    name:"isApp",
    initValue:false,
    producer(next,value,action){
    switch(action.type){
            case "no":
                next(false);//next传值，在组件中订阅就能拿到最新值
                break;
            case "yes":
                next(true);
                break;
        }
    }
})

const isCreation$ = state({
    name:"isCreation",
    initValue:false,
    producer(next,value,action){
        switch(action.type){
            case "no":
                next(false);
                break;
            case "yes":
                next(true);
                break;
        }
    }
})

const setting$ = state(
    {
        name:"setting",
        initValue:"...",
        producer(next,value,action){
            next(data.setting);
        }
    }
)

export {
    app$,
    isApp$,
    list$,
    setting$,
    isCreation$
}